import React, { useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Container,
} from 'reactstrap';

const questions = [{
    question: 'What is an AI based diet plan?',
    ans: 'AI(Artificial Intelligence) diet plan is a smart plan created based on your responses. It will provide you the non customisable diet plan as per the health condition and limited food choices.'
}, {
    question: 'What is your refund policy?',
    ans: 'The diet plans are under one time payment method. The user is not eligible for any refund on purchase of diet plan.'
}, {
  question: 'What do we offer in our Diet Plan?',
  ans: "Our diet plans are easy to follow. The diet plan is generated based on your health condition, food preferences and is composed of locally available food that doesn't burn a hole in your pocket."
}];

function FAQ(props) {
  const [open, setOpen] = useState('');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <Container className='plan-faq mt-5'>
        <h2 className='plan-faq-title'>FAQ’S</h2>
        <p className='plan-faq-description'>Everything you need to know about the product and billing.</p>
        <Accordion flush open={open} toggle={toggle}>
            {
                questions.map((obj, i) => (
                    <AccordionItem key={i}>
                        <AccordionHeader targetId={i+1}>{obj.question}</AccordionHeader>
                        <AccordionBody accordionId={i+1}>{obj.ans}</AccordionBody>
                    </AccordionItem>
                ))
            }
      </Accordion>
    </Container>
  );
}

export default FAQ;